/* eslint-disable global-require */
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { createHashHistory } from 'history'

import configureStore from 'agency/redux/configureStore'
import Root from '../../shared/roots/agency/public_pages_root'

const history = createHashHistory()
const store = configureStore()

document.addEventListener('DOMContentLoaded', () => {
  const div = document.createElement('div')
  div.setAttribute('id', 'js-public-pages')
  const domNode = document.body.appendChild(div)

  const root = ReactDOM.createRoot(domNode)

  root.render(
    <React.StrictMode>
      <Root store={store} history={history} />
    </React.StrictMode>,
  )
})
